<template>
	<div>
		<SubscriptionManager :plan="getPreselectedPlanId"></SubscriptionManager>
	</div>
</template>

<script>
	import SubscriptionManager from '../components/SubscriptionManager';
	import {mapGetters} from 'vuex';

	export default {
		computed: {
			...mapGetters([
				'getPreselectedPlanId'
			])
		},
		components: {
			SubscriptionManager 
		},
		created() {
			this.$store.commit('setCreditCardRedirection', '/');
		}
	}
</script>